module.exports = __webpack_public_path__ + "html/opportunity-table.component.html";